import { PaypalIntegrationFromComponent } from './portal-payment/integrate/method-form/paypal/paypal-integration-from/paypal-integration-from.component';
import { PortalNavigationComponent } from './portal-settings/portal-navigation/portal-navigation.component';

import { GoogleResultViewComponent } from './portal-identity/portal-identity-page/basic-information/google-result-view/google-result-view.component';
import { ColorSelectComponent } from './portal-identity/portal-identity-page/basic-information/color-select/color-select.component';
import { WebsiteAggregateAnalyticsBarComponent } from './portal-overview/website-aggregate-analytics-bar/website-aggregate-analytics-bar.component';
import { PortalSettingsComponent } from './portal-settings/portal-settings.component';
import { BasicInformationComponent } from './portal-identity/portal-identity-page/basic-information/basic-information.component';
import { PortalIdentityComponent } from './portal-identity/portal-identity.component';
import { WebsiteTemplateItemComponent } from './portal-design/templates-carousell/template-item/template-item.component';
import { TemplatesCarousellComponent } from './portal-design/templates-carousell/templates-carousell.component';

import { PortalDesignComponent } from './portal-design/portal-design.component';
import { PortalSendingMailComponent } from './portal-identity/portal-identity-page/portal-sending-mail/portal-sending-mail.component';
import { PortalMarketingOverviewComponent } from './portal-marketing/portal-marketing-overview/portal-marketing-overview.component';
import { PortalSubscribersComponent } from './portal-marketing/portal-subscribers/portal-subscribers.component';
import { PortalMarketingPageComponent } from './portal-marketing/portal-marketing-page/portal-marketing-page.component';

import { PortalFunnelsComponent } from './portal-content/portal-funnels/portal-funnels.component';

import { WebsitePagesComponent } from './portal-content/portal-pages/portal-pages.component';
import { PortalContentPageComponent } from './portal-content/portal-content-page/portal-content-page.component';

import { PortalDomainsComponent } from './portal-domains/portal-domains.component';
import { PortalViewHeadTitleAddComponent } from './portal-view-page/portal-view-head-title-add/portal-view-head-title-add.component';
import { PortalViewMainPageComponent } from './portal-view-page/portal-view-page.component';
import { ViewPortalPaymentsComponent } from './portal-payment/view/view.component';
import { PortalPaymentComponent } from './portal-payment/portal-payment.component';
import { ListPortalPaymentsComponent } from './portal-payment/list/list.component';

import { IntegratePortalPaymentsComponent } from './portal-payment/integrate/integrate.component';
import { PortalOverviewComponent } from './portal-overview/portal-overview.component';

import { PortalViewRoutingModule } from './portal-view-routing.module';
import { SharedModule } from './../../../../shared/shared.module';

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BtcpaySpecialMethodComponent } from './portal-payment/integrate/method-form/btcpay-special-method/btcpay-special-method.component';
import { VerifyBtcpayInfoComponent } from './portal-payment/integrate/method-form/btcpay-special-method/verify-btcpay-info/verify-btcpay-info.component';
import { BtcpayWalletAlertComponent } from './portal-payment/btcpay-wallet-alert/btcpay-wallet-alert.component';
import { PortalSocialLinksComponent } from './portal-social-links/portal-social-links.component';
import { SocialLinksListComponent } from './portal-social-links/social-links-list/social-links-list.component';
import { SocialLinkItemComponent } from './portal-social-links/social-links-list/social-link-item/social-link-item.component';
import { SocialLinkModalComponent } from './portal-social-links/social-link-modal/social-link-modal.component';
import { SocialLinkCreateComponent } from './portal-social-links/social-link-create/social-link-create.component';
import { SiteIdentityComponent } from './site-identity/site-identity.component';

import { StripeIntegrationFormComponent } from './portal-payment/integrate/method-form/stripe/stripe-integration-form/stripe-integration-form.component';
import { AddPortalCustomDomainComponent } from './portal-domains/add-portal-custom-domain/add-portal-custom-domain.component';
import { EditPortalSubdomainComponent } from './portal-domains/edit-portal-subdomain/edit-portal-subdomain.component';
import { PortalIdentitySettingsModalComponent } from './portal-overview/portal-identity-settings-modal/portal-identity-settings-modal.component';
import { PortalIdentitySettingsComponent } from './portal-overview/portal-identity-settings-modal/portal-identity-settings/portal-identity-settings.component';
import { PortalIdentityTooltipComponent } from './portal-view-page/portal-identity-tooltip/portal-identity-tooltip.component';

import { PaymentModule } from '../../../../features/payment/payment.module';
import { ListsModule } from '../../../../features/lists/lists.module';

import { NgApexchartsModule } from 'ng-apexcharts';
import { HighchartsChartModule } from 'highcharts-angular';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    ListsModule,
    PortalViewRoutingModule,
    NgApexchartsModule,
    HighchartsChartModule,
  ],
  declarations: [
    PortalOverviewComponent,

    GoogleResultViewComponent,
    ColorSelectComponent,

    PortalIdentityComponent,
    BasicInformationComponent,

    ListPortalPaymentsComponent,
    PortalPaymentComponent,
    ViewPortalPaymentsComponent,

    PortalSocialLinksComponent,
    SocialLinkCreateComponent,
    SocialLinksListComponent,
    SocialLinkItemComponent,
    SocialLinkModalComponent,

    PortalViewMainPageComponent,
    PortalViewHeadTitleAddComponent,
    PortalDomainsComponent,

    PortalDesignComponent,
    SiteIdentityComponent,

    // Portal Pages
    PortalContentPageComponent,
    WebsitePagesComponent,
    PortalFunnelsComponent,

    //Portal Marketing
    PortalMarketingPageComponent,
    PortalMarketingOverviewComponent,
    PortalSubscribersComponent,
    PortalSendingMailComponent,
    VerifyBtcpayInfoComponent,

    // Template Custom Items

    TemplatesCarousellComponent,
    WebsiteTemplateItemComponent,
    BtcpayWalletAlertComponent,

    // Portal Settings
    PortalSettingsComponent,
    PortalNavigationComponent,

    // Moved from SharedModule
    AddPortalCustomDomainComponent,
    EditPortalSubdomainComponent,
    PortalIdentitySettingsModalComponent,
    PortalIdentitySettingsComponent,
    WebsiteAggregateAnalyticsBarComponent,
    PortalIdentityTooltipComponent,
  ],
  exports: [
    SocialLinksListComponent,
    // Exported for other modules
    PortalSocialLinksComponent,
    AddPortalCustomDomainComponent,
    EditPortalSubdomainComponent,
    PortalIdentitySettingsModalComponent,
    PortalIdentitySettingsComponent,
    WebsiteAggregateAnalyticsBarComponent,
    PortalIdentityTooltipComponent,
    GoogleResultViewComponent,
    ColorSelectComponent,
  ],
})
export class PortalViewModule {}
